import { ProfileDataType } from "../types/ProfileDataType";

interface DocumentType {
  type: string;
  fileName: string;
  documentId: string;
}

export const mapProfileData = (data: any): ProfileDataType | null => {
  if (!data) return null;

  return {
    companyDetails: {
      outletName: data.customer.outletName,
      gstNumber: data.customer.companyGSTNumber,
      panNumber: data.customer.companyPANNumber,
      registeredAddress: data.address.registeredAddress,
      authorizedSignatory: data.customer.companySignatoryName,
      vatNo: data.customer.vatNumber,
      email: data.customer.emailId,
      pincode: data.customer.pincode,
      gstStateCode: data.customer.gstStateCode,
      documents: data.documents
        .filter((doc: DocumentType) => doc.type.startsWith("comp_"))
        .map((doc: DocumentType) => ({
          name: doc.fileName,
          link: doc.documentId,
        })),
      phoneNumber: data.customer.phoneNumber,
    },
    licenseDetails: {
      licenseName: data.address.licenseName,
      customerExciseRegistrationNumber: data.address.exciseRegistrationNumber,
      licensePanNumber: data.address.licensePANNumber,
      licenseGstNumber: data.address.licenseGSTNumber,
      licenseAddress: data.address.licenseAddress,
      gstStateCode: data.address.gstStateCode,
      ksbclCode: data.address.ksbclCode,
      documents: data.documents
        .filter((doc: DocumentType) => doc.type.startsWith("lic_"))
        .map((doc: DocumentType) => ({
          name: doc.fileName,
          link: doc.documentId,
        })),
    },
    bankDetails: {
      bankName: data.bank.bankName,
      bankBranch: data.bank.bankBranch,
      accountType: data.bank.accountType,
      accountNumber: data.bank.bankAccountNumber,
      ifscCode: data.bank.ifscCode,
      beneficiaryName: data.bank.beneficiaryName,
      accountsDepartmentPOCName: data.bank.accountsDeptPOCName,
      accountsDepartmentPOCNumber: data.bank.accountsDeptPOCNumber,
      documents: data.documents
        .filter((doc: DocumentType) => doc.type.startsWith("bank_"))
        .map((doc: DocumentType) => ({
          name: doc.fileName,
          link: doc.documentId,
        })),
    },
  };
};
